import { api } from 'utility';
import { getCreditVoucherUrl, getCreditUrl,getCarTableListUrl ,getCarTableCredittUrl} from 'URLs';
// Cards
export function postCreditVoucher(data) {
  return api.post(getCreditVoucherUrl(), data).then((res) => res.data);
}

export function getCreditAccounts(obj) {
  const params = { ...obj };
  return api.get(getCreditUrl(), { params }).then((res) => res.data);
}

/**
   * بررسی اینکه این حساب کارتابل هست یا خیر؟
   */
export function getCarTableList(data = {}) {
  return api.post(getCarTableListUrl(), data).then((res) => res.data);
}

/**
 * درصورتی که از نوع کارتابلی باشد، بن تخفیف کارتابلی با این سرویس ایجاد میشود
 */
export function getCarTableCredit(data = {}) {
  return api.post(getCarTableCredittUrl(), data).then((res) => res.data);
}



export default {
  postCreditVoucher,
  getCreditAccounts,
  getCarTableList,
  getCarTableCredit,
};
